import { render } from "./ConfigView.vue?vue&type=template&id=642d58f6&scoped=true"
import script from "./ConfigView.vue?vue&type=script&lang=js"
export * from "./ConfigView.vue?vue&type=script&lang=js"

import "./ConfigView.vue?vue&type=style&index=0&id=642d58f6&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642d58f6"]])

export default __exports__